import { DEFAULT_LANGUAGE } from '../config/constants';

export const dateFormatter = (date: string | number | Date, lang = DEFAULT_LANGUAGE) => (
  new Intl.DateTimeFormat(lang, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(date))
);

export const timeFormatter = (date: string | number | Date, lang = DEFAULT_LANGUAGE) => (
  new Intl.DateTimeFormat(lang, {
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(date))
);
